import React, { Component } from "react";
import { useQuery } from "@apollo/react-hooks";
import _ from "lodash";
import shortid from "shortid";

import "./index.less";

import { AudioCard, RedirectCard } from "../VideoCard";
import { getQueryUpdate } from "./../../lib/updateFunctions";
import { isLoggedIn, logout } from "./../../lib/session";
import { VIDEO_LIST_QUERY } from "./../../lib/graphqlQueries";

const getCategorizedVideos = videos =>
  videos.reduce((acc, video) => {
    const result = { ...acc };
    const {
      title,
      content,
      videoUrl,
      mediaDetails,
      audioSettings,
      videoSettings,
      videoId,
      date,
      sections: { nodes: sectionList } = {}
    } = video;

    const { audio = {} } = audioSettings || {};

    let cardType;
    if (audio && audio.mediaItemUrl) cardType = "audio";
    else if (videoSettings && videoSettings.videoUrl) cardType = "redirect";

    if (cardType) {
      sectionList.map(section => {
        const { sectionId, name, sortOrder } = section;
        const entry = [
          {
            title,
            content,
            videoUrl,
            mediaDetails,
            audioSettings,
            videoSettings,
            videoId,
            date,
            cardType
          }
        ];
        result[sectionId] = {
          ...result[sectionId],
          ...{
            sectionId,
            name,
            sortOrder,
            videos: !result[sectionId]
              ? entry
              : [...result[sectionId].videos, ...entry]
          }
        };
        return true;
      });
    }
    return result;
  }, {});

const getCategoryHeader = (sectionId, name) => (
  <section className="video-header" key={sectionId}>
    <h3>{name}</h3>
  </section>
);

const getVideos = (videoCards, winWidth, style) => {
  const videoStyle = { ...style, width: `${winWidth}px` };
  return (
    <div
      key={shortid.generate()}
      className="video-container"
      style={videoStyle}
    >
      <div className="videos" style={{ width: `${videoCards.length * 250}px` }}>
        {videoCards}
      </div>
    </div>
  );
};

export default props => {
  const {
    winWidth = 0,
    section = "medical",
    playVideo,
    currentlyPlaying,
    style = {},
    displayHeader = true,
    track
  } = props;
  const videoIds = {};
  const cursor = "";
  const variables = { cursor, section };
  const { data, loading, error, fetchMore } = useQuery(VIDEO_LIST_QUERY, {
    variables,
    errorPolicy: "all"
  });

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    if (isLoggedIn()) {
      logout();
    } else {
      return <p>Error getting data: Please reload your page.</p>;
    }
  }

  const {
    videos: { nodes: videoList = [], pageInfo: { endCursor } = {} } = {}
  } = data || {};
  let categorizedVideos = [];

  if (videoList.length > 0 && endCursor) {
    fetchMore({
      variables: {
        cursor: endCursor
      },
      updateQuery: (prev, { fetchMoreResult }) =>
        getQueryUpdate(prev, fetchMoreResult, "videos")
    });
  }

  if (videoList.length > 0) categorizedVideos = getCategorizedVideos(videoList);

  const response = _.sortBy(_.values(categorizedVideos), "sortOrder").map(
    categoryVideo => {
      const { sectionId, name, videos } = categoryVideo;
      const videoCards = videos
        .map(video => {
          const { videoId, cardType } = video;
          if (!videoIds[videoId]) {
            videoIds[videoId] = 1;
            let VideoCard;
            if (cardType === "audio") VideoCard = AudioCard;
            else if (cardType === "redirect") VideoCard = RedirectCard;

            if (VideoCard)
              return (
                <VideoCard
                  key={videoId}
                  post={video}
                  currentlyPlaying={currentlyPlaying}
                  playVideo={playVideo}
                  track={track}
                />
              );
          }
          return null;
        })
        .filter(n => n);
      return [
        displayHeader && getCategoryHeader(sectionId, name),
        getVideos(videoCards, winWidth, style)
      ];
    }
  );
  return <section className="video-list">{response}</section>;
};
